import React, { useEffect, useImperativeHandle } from 'react'

import { IActionComponentAPI, IActionComponentProps, IActionSubmitResponse } from '../types'
import { DEFAULT_WIDGET_WIDTH, BANNER_WIDTH, ViewportOrientation } from '@aytm/app/swidget/base/modules/viewport/types'

import useSession from '../../session/useSession'
import useViewport from '../../modules/viewport/useViewport'
import EndView from './View'
import Banner from './Banner'

import style from './style.module.scss'

const EndAction = React.memo(
  React.forwardRef<IActionComponentAPI, IActionComponentProps>(({ action }, ref) => {
    const session = useSession()
    const viewport = useViewport()
    const showBanner = Boolean(action?.banner && action?.banner?.type)
    const redirect = !action.preview && action.redirect_url?.length

    useEffect(() => {
      if (redirect) {
        window.location.href = action.redirect_url
      }
    }, [redirect, action?.redirect_url])

    useEffect(() => {
      session.enableNavigation(false)
      session.clearRepeatVideos()
      session.progress.updateFromAction(action)
      session.currentTarget = null
    }, [session, action])

    useEffect(() => {
      const width = DEFAULT_WIDGET_WIDTH.DESKTOP + BANNER_WIDTH

      if (showBanner && !viewport.mobile && viewport.width > width) {
        session.setWidgetWidth(width)
      } else {
        session.setWidgetWidth(null)
      }
    }, [session, viewport, showBanner])

    useImperativeHandle<IActionComponentAPI, IActionComponentAPI>(
      ref,
      () => {
        return {
          tryNext() {
            return true
          },
          tryPrev() {
            return false
          },
          showValidation() {
            //
          },
          get submitResponse() {
            const submitResponse: IActionSubmitResponse[] = []
            return submitResponse
          },
          get currentQuestionModel(): null {
            return null
          }
        }
      },
      []
    )

    if (redirect) return null

    return (
      <div
        className={`${style.EndAction} ${style.action} ${showBanner ? style.banner : ''} ${
          viewport.mobile ? style.mobile : ''
        } ${viewport.orientation == ViewportOrientation.LANDSCAPE ? style.landscape : ''}`}
      >
        {showBanner && <Banner url={action.banner.url} type={action.banner.type} />}
        <EndView action={action} />
      </div>
    )
  }),
  (prevProps, nextProps) => prevProps.action === nextProps.action
)

EndAction.displayName = 'EndAction'

export default EndAction
